import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import NetMeteringPolicy from './net-metering-policy';
import NetMeteringPolicyDetail from './net-metering-policy-detail';
import NetMeteringPolicyUpdate from './net-metering-policy-update';
import NetMeteringPolicyDeleteDialog from './net-metering-policy-delete-dialog';

const NetMeteringPolicyRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<NetMeteringPolicy />} />
    <Route path="new" element={<NetMeteringPolicyUpdate />} />
    <Route path=":id">
      <Route index element={<NetMeteringPolicyDetail />} />
      <Route path="edit" element={<NetMeteringPolicyUpdate />} />
      <Route path="delete" element={<NetMeteringPolicyDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NetMeteringPolicyRoutes;
